import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {Box, Tab, Tabs} from "@mui/material";

const yardMarker = {
    fillColor: "#FFFFFF",
    fontSize: 36,
    height: 56,
    radius: 32,
    strokeWidth: 8,
    textDx: 52,
    textDy: 40,
    textFontWeight: "600",
    width: 106
};

export default class GolfShotDetails extends React.Component {

    state = {
        newMessage: '',
    }

    renderHoleSelector = (golferId) => {
        return (
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={this.props.pickedGolfers[golferId].Show_Hole} onChange={this.handleHoleDetailsChange} variant="fullWidth">
                    {[...Array(18).keys()].map((hole) => {
                        return <Tab sx={{minWidth: '1px'}} key={golferId+'shotDetailsHoleSelector'+hole} label={hole+1} data-golfer-id={golferId}/>
                    })}
                </Tabs>
            </Box>
        );
    }

    u = (e, t) => {
        if ("number" == typeof e)
            return e * (t ? 2 : 1);
        if (2 !== e.length)
            throw Error("invalid trail item size: ".concat(JSON.stringify(e)));
        let[l,r] = e;
        return t ? l : r
    }
    
    renderStrokeDistance = (stroke) => {
        let yellow = "#F5A81C";
        let gold = "#F9CD7E";
        let black = "#000000";
        let white = "#FFFFFF";

        let {x: t, y: l, yardage: o, strokeColor: i} = stroke
            , c = yardMarker.width / 2
            , h = yardMarker.height / 2;
        return (
            <Fragment>
                <rect x={t-c} y={l-h} width={yardMarker.width} height={yardMarker.height} rx={yardMarker.radius}
                      fill={i} stroke={i} strokeWidth={yardMarker.strokeWidth}/>
                <text textAnchor="middle" x={t-c} y={l-h} dx={yardMarker.textDx} dy={yardMarker.textDy}
                      fontWeight={yardMarker.textFontWeight} fontSize={yardMarker.fontSize} fill={i === yellow || i === gold ? black : white}>{o}</text>
            </Fragment>
        );
    }

    holeScoreText(shotDetails, stroke) {
        if (stroke.strokeNumber > shotDetails.par + 1) {
            return 'dbl bogey +';
        }
        else if (stroke.strokeNumber > shotDetails.par) {
            return 'bogey';
        }
        else if (stroke.strokeNumber === shotDetails.par) {
            return 'par';
        }
        else if (stroke.strokeNumber === shotDetails.par - 1) {
            return 'birdie';
        }
        else if (stroke.strokeNumber === 1) {
            return 'ace';
        }
        else if (stroke.strokeNumber === shotDetails.par - 2) {
            return 'eagle';
        }
        else if (stroke.strokeNumber === shotDetails.par - 3) {
            return 'albatross';
        }
        else {
            return 'unknown';
        }
    }

    handleHoleDetailsChange = (event, newValue) => {
        let gid = event.target.dataset['golferId'];
        this.props.pickedGolfers[gid].Show_Hole = newValue;
    };

    handlePlayByPlayButtonClick = (event) => {
        let gid = event.currentTarget.dataset['golferId'];
        this.props.pickedGolfers[gid].Show_PBP = !this.props.pickedGolfers[gid].Show_PBP;
    }

    renderShotDetailsContainer = () => {
        return (
            <div className="GolfShotDetailsContainer">
                {this.props.watchedGolfers.map((golferId) => {
                    if (this.props.pickedGolfers[golferId] && this.props.pickedGolfers[golferId].Shot_Details) {
                        let pickedGolfer = this.props.pickedGolfers[golferId];
                        let roundNum = this.props.configData.current_round;
                        if (pickedGolfer.Shot_Details[roundNum-1]) {
                            let shotDetails = pickedGolfer.Shot_Details[roundNum-1];
                            // Show_Hole is the course hole number, may not be the nth hole the golfer is playing (if they started on 10).  So
                            // convert currentHole to the nth hole when passing in the shot details.
                            let currentHole = pickedGolfer.Show_Hole;
                            if (shotDetails.holes[0].holeNumber === 10) {
                                currentHole = (currentHole + 9) % 18;
                            }
                            let courseId = this.props.pickedGolfers[golferId].course_ids[roundNum-1];
                            if (this.props.coursesData[courseId].scoring_level === 'TOURCAST') {
                                // Maybe move this check outside the TOURCAST check if it applies to the non-tourcast display too
                                if (shotDetails.holes[currentHole].strokes.length < 1 && currentHole > 0) {
                                    currentHole = currentHole - 1;
                                }
                                return this.renderShotDetails(this.props.pickedGolfers[golferId], shotDetails.holes[currentHole], courseId);
                            }
                            else {
                                // TODO: display shot details without the hole picture or nice graphics
                                return '';
                            }
                        }
                        else {
                            return '';
                        }
                    }
                    else {
                        return '';
                    }
                })}
            </div>
        );
    }

    renderShotDetails = (pickedGolfer, shotDetails, courseId) => {
        let containerHeight = 415.711;
        let containerWidth = 970;
        let svgHeight = 1314;
        let svgWidth = 3072;
        let pinX = (shotDetails.pinOverview.leftToRightCoords.enhancedX * svgWidth) - 10,
            pinY = (shotDetails.pinOverview.leftToRightCoords.enhancedY * svgHeight) - 67.2 + 2;
        //let imgsrc = "https://pga-tour-res.cloudinary.com/tourcastPickle/" + shotDetails.holePickleLeftToRightAsset.imagePath.split(",")[3].split("/")[1] + "_land.png";
        let imgsrc = "https://www.pickfive.org/images/golf/holes/" + this.props.configData.current_year + "/holes_" + this.props.configData.current_year + "_" +  this.props.configData.tour_code.toLowerCase() + "_" + this.props.configData.Perm_Num + "_" + courseId + "_overhead_full_" + shotDetails.holeNumber + "_land.png";
        let currentStroke = (shotDetails.strokes.length === 0 ? null : shotDetails.strokes[shotDetails.strokes.length-1]);
        // ratio 2.333351775632591, 976 - (106 * ratio) / 2
        return (
            <div className="GolfShotDetailsContainerRow" key={`golfShotDetailsRow-${pickedGolfer.Id}`}>
                <div className="GolfShotDetailsGolferName">{pickedGolfer.Name}</div>
                {this.renderHoleSelector(pickedGolfer.Id)}
                <div style={{width: `${containerWidth}px`, height: `${containerHeight}px`, position: "relative"}} className="GolfShotDetails">
                    <div className="chakra-aspect-ratio css-v6e02t">
                        <img
                            alt="Hole pickle"
                            loading="lazy"
                            decoding="async"
                            data-nimg="fill"
                            src={imgsrc}
                            style={{
                                position: 'absolute',
                                height: '100%',
                                width: '100%',
                                inset: '0',
                                objectFit: 'cover',
                                color: 'transparent'
                            }}/>
                        <div className="css-1w7rdu9">
                            <svg className="shot-trails" viewBox={`0 0 ${svgWidth} ${svgHeight}`}
                                 style={{position: 'absolute'}}>

                                {/* Draw shot lines */}
                                {shotDetails.strokes.map((stroke, i) => {
                                    let fx = stroke.overview.leftToRightCoords.fromCoords.enhancedX * svgWidth,
                                        fy = stroke.overview.leftToRightCoords.fromCoords.enhancedY * svgHeight,
                                        tx = stroke.overview.leftToRightCoords.toCoords.enhancedX * svgWidth,
                                        ty = stroke.overview.leftToRightCoords.toCoords.enhancedY * svgHeight;
                                    return (
                                        <path d={`M${fx} ${fy} L${tx} ${ty}`} stroke="#0084FF" strokeWidth="6" key={`shotDetailsPath-${pickedGolfer.Id}-s${i}`}/>
                                    )
                                })}
                                {/* Draw starting circle */}
                                {shotDetails.strokes.length ?
                                    <circle cx={shotDetails.strokes[0].overview.leftToRightCoords.fromCoords.enhancedX * svgWidth}
                                            cy={shotDetails.strokes[0].overview.leftToRightCoords.fromCoords.enhancedY * svgHeight} r="18"
                                            stroke="white" fill="#ffffff"/> : ''
                                }
                                {/* Draw shot distances */}
                                {shotDetails.strokes.map((stroke, i) => {
                                    if (stroke.markerText === '0' || Number(stroke.markerText) < 30) {
                                        return '';
                                    }
                                    let x = (((stroke.overview.leftToRightCoords.toCoords.enhancedX * svgWidth) -
                                            (stroke.overview.leftToRightCoords.fromCoords.enhancedX * svgWidth)) / 2) + (stroke.overview.leftToRightCoords.fromCoords.enhancedX * svgWidth) -
                                        (yardMarker.width / 2);
                                    let y = (((stroke.overview.leftToRightCoords.toCoords.enhancedY * svgHeight) -
                                            (stroke.overview.leftToRightCoords.fromCoords.enhancedY * svgHeight)) / 2) + (stroke.overview.leftToRightCoords.fromCoords.enhancedY * svgHeight) -
                                        (yardMarker.height / 2);
                                    return (
                                        <Fragment key={`golfShotDetailsFrag2-${pickedGolfer.Id}-${i}`}>�
                                            <rect x={x} y={y} width="106" height="56"
                                                  rx="32"
                                                  fill="#0084FF" stroke="#0084FF" strokeWidth="8"/>
                                            <text textAnchor="middle" x={x} y={y} dx="52"
                                                  dy="40"
                                                  fontWeight="600" fontSize="36" fill="#FFFFFF">{stroke.markerText}
                                            </text>
                                        </Fragment>
                                    )
                                })}

                                {/* Draw pin on green svg */}
                                <svg x={pinX} y={pinY} width="40" height="67.2" viewBox="0 0 12 24" fill="none">
                                    <line x1="1.5" y1="1" x2="1.5" y2="23" stroke="black" strokeOpacity="0.05"></line>
                                    <path d="M3 1L6.75 6H10.5L12 12H4.5L3 10V7V1Z" fill="#FAE100"></path>
                                    <path d="M3 1V10L4.5 12V10.5V7.5L6.75 6L3 1Z" fill="#BBA900"></path>
                                    <path
                                        d="M5 22.5C5 23.3284 3.88071 24 2.5 24C1.11929 24 0 23.3284 0 22.5C0 21.6716 1.11929 21 2.5 21C3.88071 21 5 21.6716 5 22.5Z"
                                        fill="black" fillOpacity="0.5"></path>
                                    <path d="M2 1H3V23H2V1Z" fill="white"></path>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M2 10L2 1L3 1L3 10L2 10Z"
                                          fill="#7D7000"></path>
                                    <path
                                        d="M3 0.5C3 0.776142 2.77614 1 2.5 1C2.22386 1 2 0.776142 2 0.5C2 0.223858 2.22386 0 2.5 0C2.77614 0 3 0.223858 3 0.5Z"
                                        fill="white"></path>
                                </svg>

                                {/* Draw shot count circles */}
                                {shotDetails.strokes.map((stroke, i) => {
                                    let tx = stroke.overview.leftToRightCoords.toCoords.enhancedX * svgWidth,
                                        ty = stroke.overview.leftToRightCoords.toCoords.enhancedY * svgHeight;
                                    return (
                                        <Fragment key={`golfShotDetailsStrokesFragment-${pickedGolfer.Id}-${i}`}>
                                            {stroke.finalStroke ?
                                                <circle cx={tx} cy={ty} r="30" stroke="#FFFFFF" strokeWidth="4" fill="#0084FF"></circle> :
                                                <circle cx={tx} cy={ty} r="30" fill={stroke.strokeType === "PENALTY" ? "red" : "#0084FF"}></circle>
                                            }
                                            <text textAnchor="middle" x={tx} y={ty}
                                                  dy=".35em"
                                                  fontWeight="600" fontSize="40" fill="white">{stroke.strokeNumber}
                                            </text>
                                        </Fragment>
                                    )
                                })}
                            </svg>
                        </div>
                    </div>

                    {/* Draw the hole information overlay */}
                    <div className="GolfShotDetailsInfoOverlayContainer">
                        <div className="GolfShotDetailsInfoOverlay">
                            <span style={{fontSize: "58px"}} className="GolfShotDetailsInfoHoleRow">{shotDetails.holeNumber}</span>
                            <div style={{width: "16px", height: "16px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                            <span style={{fontSize: "13px", lineHeight:"14px"}} className="chakra-text GolfShotDetailsInfoHoleRow">PAR</span>
                            <div style={{width: "4px", height: "4px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                            <span style={{fontSize: "35px", lineHeight:"38px"}} className="chakra-text GolfShotDetailsInfoHoleRow">{shotDetails.par}</span>
                            <div style={{width: "24px", height: "24px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                            <span style={{fontSize: "13px", lineHeight:"14px"}} className="chakra-text GolfShotDetailsInfoHoleRow">YARDS</span>
                            <div style={{width: "4px", height: "4px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                            <span style={{fontSize: "35px", lineHeight:"38px"}} className="chakra-text GolfShotDetailsInfoHoleRow">{shotDetails.yardage}</span>
                            <div style={{width: "24px", height: "24px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                            <span style={{fontSize: "13px", lineHeight:"14px"}} className="chakra-text GolfShotDetailsInfoHoleRow">RANK</span>
                            <div style={{width: "4px", height: "4px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                            <span style={{fontSize: "35px", lineHeight:"38px"}} className="chakra-text GolfShotDetailsInfoHoleRow">{shotDetails.rank}</span>
                            <div style={{width: "24px", height: "24px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                            <span style={{fontSize: "13px", lineHeight:"14px"}} className="chakra-text GolfShotDetailsInfoHoleRow">AVG</span>
                            <div style={{width: "4px", height: "4px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                            <span style={{fontSize: "35px", lineHeight:"38px"}} className="chakra-text GolfShotDetailsInfoHoleRow">{shotDetails.averageScore}</span>
                            <div style={{width: "24px", height: "24px"}} className="GolfShotDetailsInfoHoleRowSpacer"></div>
                        </div>


                        <div className={pickedGolfer.Show_PBP ? "GolfShotDetailsRightSidePanelOpen" : "GolfShotDetailsRightSidePanelClosed"}>
                            <div className="GolfShotDetailsRightSidePanelButtonContainer">
                                <button tabIndex="0" className="GolfShotDetailsRightSidePanelButton" onClick={this.handlePlayByPlayButtonClick} data-golfer-id={pickedGolfer.Id}>
                                    <div className="GolfShotDetailsPlayByPlayButtonContainer">
                                        <span className="GolfShotDetailsPlayByPlayButtonText">Play By Play</span></div>
                                </button>
                            </div>
                        </div>

                        {/* Draw the play by play shot container */}
                        <div className={pickedGolfer.Show_PBP ? "GolfShotDetailsPlayByPlayContainerOpen" : "GolfShotDetailsPlayByPlayContainerClosed"}>
                            {pickedGolfer.Show_PBP ? (
                                <div className="GolfPBP-nsinwu">
                                    <div className="GolfPBP-1ufrzn0">
                                        <h2 className="GolfPBP-1h0wur3">Play By Play</h2>
                                        <button type="button" className="chakra-button GolfPBP-18ffrip" aria-label="Close button" onClick={this.handlePlayByPlayButtonClick} data-golfer-id={pickedGolfer.Id}>
                                            <svg viewBox="0 0 13 12" focusable="false" className="chakra-icon GolfPBP-275bqz" aria-label="Close">
                                                <path fill="currentColor" fillRule="evenodd"
                                                      d="M6.5 4.94L4.202 2.64l-1.06 1.06L5.438 6 3.141 8.298l1.061 1.06L6.5 7.062l2.298 2.298 1.06-1.06L7.562 6l2.298-2.298-1.06-1.06L6.5 4.938z"
                                                      clipRule="evenodd"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="GolfPBP-1sabknn"/>
                                    <div aria-orientation="horizontal" role="presentation" className="chakra-divider GolfPBP-2i83vv"/>
                                    <div className="GolfPBP-1sabknn"/>
                                    <div data-simplebar="init" className="dark-theme simplebar-scrollable-y GolfPBPSimpleBarContainer">
                                        <div className="simplebar-wrapper">
                                            <div className="simplebar-height-auto-observer-wrapper">
                                                <div className="simplebar-height-auto-observer"/>
                                            </div>
                                            <div className="simplebar-mask">
                                                <div className="simplebar-offset">
                                                    <div className="simplebar-content-wrapper" tabIndex="0" role="region" aria-label="scrollable content">
                                                        <div className="simplebar-content">
                                                            <div className="GolfPBP-pkn9ma">
                                                                {shotDetails.strokes.map((stroke) =>
                                                                    <div className="GolfPBP-145umzp">
                                                                        <div className="GolfPBP-29rmbm">
                                                                            <div className="GolfPBP-1vysk0b"/>
                                                                            <div className="GolfPBP-1170h9y">
                                                                                <div className="GolfPBP-12lbfbz">
                                                                                    <span className="chakra-text GolfPBP-1ph61kr">Shot {stroke.strokeNumber}</span>
                                                                                    <span className="chakra-text GolfPBP-kmsc9k">{stroke.playByPlay}</span>
                                                                                    {stroke.finalStroke ? (
                                                                                        <div className="GolfPBP-1xzhtrx">
                                                                                            <div className="GolfPBP-1u4uyif">
                                                                                                <span className="chakra-text GolfPBP-1s3yo9o">{this.holeScoreText(shotDetails, stroke)}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : ''}
                                                                                </div>
                                                                            </div>
                                                                            <div className="GolfPBP-1vysk0b"/>
                                                                            <div role="presentation"
                                                                                 className="chakra-divider GolfPBP-s08p0u"/>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="GolfPBP-1qzcbpb"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="simplebar-placeholder GolfPBP-kjdeda"/>
                                        </div>
                                        {/*
                                    <div className="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                        <div className="simplebar-scrollbar" style="width: 0px; display: none;"/>
                                    </div>
                                    <div className="simplebar-track simplebar-vertical" style="visibility: visible;">
                                        <div className="simplebar-scrollbar" style="height: 261px; transform: translate3d(0px, 0px, 0px); display: block;"/>
                                    </div>
                                    */}
                                    </div>
                                </div>) : ''
                            }
                        </div>

                        {currentStroke && !pickedGolfer.Show_PBP ? (
                            <div className="GolfShotDetailsBottomInfo">
                                <div className="GolfShotDetailsLastShotContainer">
                                    <div className="GolfShotDetailsLastShotBox">
                                        <div className="GolfShotDetailsLastShotPill">
                                            <span className="GolfShotDetailsLastShotNumber">Shot {currentStroke.strokeNumber}</span>
                                            <span className="GolfShotDetailsLastShotText">{currentStroke.playByPlay}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>) : ''
                        }
                    </div>
                </div>
            </div>
        );
    }
    
    render () {
        return this.renderShotDetailsContainer();
    }
}

GolfShotDetails.propTypes = {
    pickedGolfers: PropTypes.object.isRequired,
    configData: PropTypes.object.isRequired,
    watchedGolfers: PropTypes.array.isRequired,
    coursesData: PropTypes.object.isRequired,
}
